<template>
  <div>
    <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
      <div>
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item has-feedback label="Code" prop="code">
            <a-input v-model="form.code" placeholder="Enter text" />
          </a-form-model-item>
          <a-form-model-item has-feedback label="Title" prop="title">
            <a-input v-model="form.title" placeholder="Enter text" />
          </a-form-model-item>
        </a-form-model>
        <a-divider orientation="left">
          INFOMARTION
        </a-divider>
        <a-descriptions :column="1">
          <a-descriptions-item label="Created by">
            {{ form.author && (form.author.fullname || form.author.username) }}
          </a-descriptions-item>
          <a-descriptions-item label="Created at">
            {{ form.createdAt | formatDateHour }}
          </a-descriptions-item>
          <a-descriptions-item label="Updated at">
            {{ form.updatedAt | formatDateHour }}
          </a-descriptions-item>
        </a-descriptions>

        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-popconfirm
            title="Confirm action?"
            ok-text="Delete"
            cancel-text="No"
            @confirm="deleteDocumentType"
          >
            <a-button
              :loading="loadingDelete"
              style="margin-right: 5px; float: left;"
              type="danger"
              icon="delete"
            >
              Delete
            </a-button>
          </a-popconfirm>

          <a-button
            @click="closeDrawerUpdateDocumentType"
            style="margin-right: 5px;"
          >
            Close
          </a-button>
          <a-button
            type="primary"
            @click="updateDocumentType"
            :loading="loadingUpdate"
          >
            Update
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import getQuery from "../../data/getData";
import postQuery from "../../data/postData";
export default {
  props: {
    updateDocumentTypeOnView: {
      type: Function,
      default: null,
    },
    deleteDocumentTypeOnView: {
      type: Function,
      default: null,
    },

    closeDrawerUpdateDocumentType: {
      type: Function,
      default: null,
    },
    idDocumentType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      loadingUpdate: false,
      loadingDelete: false,
      visible: false,
      form: {
        code: null,
        title: null,
      },
      rules: {
        code: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
          {
            min: 1,
            message: "Code must not be less than 1 characters",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    getDocumentType() {
      this.$apollo
        .query({
          query: getQuery.queryGetDocumentType,

          variables: {
            id: this.idDocumentType,
          },
        })
        .then(({ data }) => {
          this.form = { ...data.getDocumentType };
          this.loading = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Không lấy được chi tiết loại công văn",
          });
          console.log("Không lấy được chi tiết loại công văn", error);
        });
    },
    updateDocumentType() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryUpdateDocumentType,
              variables: {
                code: this.form.code,
                title: this.form.title,
                id: this.idDocumentType,
              },
            })
            .then(({ data }) => {
              if (data?.updateDocumentType) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Cập nhật loại công văn thành công",
                });

                this.updateDocumentTypeOnView(data?.updateDocumentType);
                this.closeDrawerUpdateDocumentType();
              }

              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Cập nhật loại công văn không thành công",
              });
              console.log("Không cập nhật được loại công văn", error);
              this.loadingUpdate = false;
            });
        } else {
          return false;
        }
      });
    },
    deleteDocumentType() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: postQuery.queryDeleteDocumentType,
          variables: {
            id: this.idDocumentType,
          },
        })
        .then(({ data }) => {
          if (data?.deleteDocumentType) {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa loại công văn thành công",
            });
            this.deleteDocumentTypeOnView(data.deleteDocumentType);
            this.closeDrawerUpdateDocumentType();
          }
          this.loadingDelete = false;
        })
        .catch((error) => {
          this.loadingDelete = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Xóa loại công văn không thành công" + error,
          });
          console.log("Xóa loại công văn không thành công", error);
        });
    },
  },

  created() {
    this.getDocumentType();
  },
};
</script>
<style></style>
